const config = {
  backendHost: '$VITE_BACKEND_HOST',
  backendHost2: 'VITE_BACKEND_HOST',
  formHost: '$VITE_FORM_HOST',
  appVersion: '$VITE_TAG_VERSION',
  gtmId: '$VITE_APP_GTM_ID',
}
console.log(config)


// 代入與替換
export default (name) => {
  if (!(name in config)) {
    return
  }

  const value = config[name]
  if (!value) {
    return
  }

  // 搜尋前綴為 $VUE_APP_ 開頭的Value 並代入替換 .env 對應的值
  if (value.startsWith('$VITE_')) {
    const envName = value.substr(1)
    const envValue = process.env[envName]

    console.log('dynamic', envValue)

    if (envValue) {
      return envValue
    }
  } else {
    console.log('else :', value)
    return value
  }
}
